/**
 * @ipc/admin-ui · shared/lib/rbac — браузерная копия RBAC-движка.
 *
 * Совместима с `hasPermissionWithWildcard` из @ipc/core (раздел 09): супер-админ (`*` или
 * `admin.*`), точное совпадение, wildcard по категориям (`prefix.*`) с поддержкой обоих
 * разделителей `.` и `:`. Только для UX-скрытия действий/пунктов меню — АВТОРИТЕТ остаётся
 * за backend (401/403). Перенос as-is из legacy src/islands/_shared/rbac.ts.
 */

/**
 * Есть ли у набора прав `permissions` право `requiredCode` (с учётом wildcard).
 * Семантика дословно повторяет @ipc/core: сначала супер-админ, потом точное совпадение,
 * затем walk по префиксам от самого специфичного к самому общему.
 */
export function hasPermissionWithWildcard(permissions: string[], requiredCode: string): boolean {
  if (permissions.includes('*') || permissions.includes('admin.*')) {
    return true;
  }
  if (permissions.includes(requiredCode)) {
    return true;
  }
  const parts = requiredCode.split(/[.:]/);
  const separator = requiredCode.includes(':') ? ':' : '.';
  for (let i = parts.length - 1; i > 0; i--) {
    const wildcardCode = parts.slice(0, i).join(separator) + separator + '*';
    if (permissions.includes(wildcardCode)) {
      return true;
    }
  }
  return false;
}

/** Может ли пользователь с этими правами выполнить действие `code` (UX-скрытие кнопок/пунктов меню). */
export function can(permissions: string[], code: string): boolean {
  return hasPermissionWithWildcard(permissions, code);
}
